
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination])
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { PronosticoHidricoApi } from '@/domain/entities/Api'
import { Chart } from 'highcharts-vue'
import { isMobile } from './helpers/utils'

@Component({
  components: {
    'highcharts': Chart
  }
})
export default class InfoView extends Vue {
  @Prop({ type: Object }) infoviewData!: PronosticoHidricoApi
  @Prop() title!: string
  @Prop() link!: string
  @Prop() subtitle!: string
  @Prop() subtitle2!: string
  @Prop() emptyResponse!: string
  @Prop() date!: string
  @Prop() data!: any
  @Prop() chartOptions!: any

  tabModel = 0

  isMobile = isMobile()

  swiperInstance: any = null

  mounted () {
    this.$nextTick(() => this.initSwiper(true))
  }

  beforeDestroy () {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true)
      this.swiperInstance = null
    }
  }

  initSwiper (forceRecreate = false) {
    const el: any = this.$refs.mySwiper
    if (!el) return

    if (this.swiperInstance && forceRecreate) {
      this.swiperInstance.destroy(true, true)
      this.swiperInstance = null
    }

    if (this.swiperInstance) {
      this.swiperInstance.update()
      return
    }

    this.swiperInstance = new (Swiper as any)(el, {
      ...this.swiperOptions,
      // más robusto en Vue (re-render)
      observer: true,
      observeParents: true,
      // asegura que la paginación se encuentre dentro del contenedor real
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      // botones sólo si existen (desktop)
      navigation: this.isMobile
        ? undefined
        : { nextEl: '#swiper-btn-next', prevEl: '#swiper-btn-prev' }
    })
  }  
  chartOptionsBase: Highcharts.Options = {
    time: {
      useUTC: false
    },
    title: { style: { display: 'none' } },
    chart: {
      spacingLeft: 3,
      spacingRight: 3,
      zoomType: 'xy'
    },
    series: [],
    yAxis: {
      title: undefined,
      type: 'linear',
      labels: {
        style: {
          fontSize: '8px'
        }
      }
    },
    xAxis: {
      title: undefined,
      type: 'datetime',
      labels: {
        style: {
          fontSize: '8px'
        }
      }
    },
    legend: {
      enabled: false
    },
    credits: { enabled: false }
  }

  swiperOptions = {
    initialSlide: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '#swiper-btn-next',
      prevEl: '#swiper-btn-prev'
    }
  }

  get computedChartOptions (): Highcharts.Options[] {
    return this.chartOptions && this.chartOptions.map ? this.chartOptions.map((chartOption: any) => ({
      ...this.chartOptionsBase,
      ...chartOption
    })) : []
  }

  @Watch('computedChartOptions')
  onChartOptionsChanged () {
    this.$nextTick(() => {
      this.initSwiper(true)
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(0, 0)
      }
    })
  }

  get hasSeries (): boolean {
    const countSeries = this.computedChartOptions.reduce((accumulator: number, chartOption) => {
      const series = (chartOption.series && chartOption.series.length) || 0
      return accumulator + series
    }, 0)
    return countSeries > 0
  }
}
